import FormPage from '../../components/Pages/FormPage/FormPage';
import { serviceTypes } from '../initData/services';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function FormPageWrapper({
  addressInput,
  serviceId,
  cityId,
  ageId,
  robotId,
  occurrenceId,
}) {
  const isWorkshopService = serviceId === serviceTypes.workshop;
  const isSummerplayService = serviceId === serviceTypes.summerplay;
  const isAcademyService = serviceId === serviceTypes.academy;
  let shouldBePage = pages.contact;
  let conditionTypes = {
    page: true,
    service: true,
    franchise: true,
    robot: isWorkshopService,
    age: isWorkshopService,
    workshops: isWorkshopService,
    summerplays: isSummerplayService,
    academies: isAcademyService,
    occurrence: true,
  };

  if (addressInput) {
    shouldBePage = pages.contactWithAddress;
    conditionTypes.workshops = false;
    conditionTypes.occurrence = false;
  }

  return (
    <PageWrapper
      pageToLoad={addressInput ? <FormPage addressInput /> : <FormPage />}
      shouldBePage={shouldBePage}
      serviceId={serviceId}
      cityId={cityId}
      ageId={ageId}
      robotId={robotId}
      occurrenceId={occurrenceId}
      conditions={conditionTypes}
    />
  );
}
